import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { STREAK_STATUSES } from '@/helpers/constants';
import IconClose from './icon_close.svg';
import IconWarn from './icon_warn.svg';
import s from './index.module.scss';

export const StreakLossMessage = ({ status }) => {
  const [hide, setHide] = useState(false);
  const { t } = useTranslation('streak');

  if (status?.status !== STREAK_STATUSES.paused || hide) return null;

  const onClickClose = () => {
    setHide(true);
  };

  return (
    <div className={s.wrapper}>
      <img
        src={IconWarn}
        alt="warning"
        width={40}
        height={40}
        className={s.icon}
      />
      <div className={s.content}>
        <div className="f-small-accent">{t('streak_loss_msg.title')}</div>
        <div
          className="f-small-regular"
          style={{ color: 'var(--Grey-900-Deep, #52626F)' }}
        >
          {t('streak_loss_msg.desc')}
        </div>
      </div>
      <button type="button" className={s.btn_close} onClick={onClickClose}>
        <img src={IconClose} alt="close" width={32} height={32} />
      </button>
    </div>
  );
};
